import type { HTMLAttributes } from 'react';

export const getStepIndicatorItemAttrs = (isCurrent: boolean) => ({
  ...(isCurrent && { 'aria-current': 'step' as HTMLAttributes<HTMLElement>['aria-current'] }),
});
